export default __webpack_public_path__ + "569105870606cb3fc3c6c0131e85293d.png";